<template>
  <div class="app flex-row align-items-center">
    <loading
      :active.sync="isLoading"
      :can-cancel="false"
      :is-full-page="true"
    />
    <div class="container">
      <div class="row justify-content-center">
        <b-col md="8">
          <b-alert
            :show="showDismissibleAlert"
            variant="danger"
            dismissible
            ref="alerta"
            >CNPJ, usuário ou senha incorreto!</b-alert
          >
        </b-col>
      </div>
      <b-row class="justify-content-center">
        <b-col md="8">
          <b-card-group>
            <b-card no-body class="p-4">
              <b-card-body>
                <b-form>
                  <h1>Login</h1>
                  <p class="text-muted">Entre na sua conta</p>
                  <b-alert show variant="danger" v-if="usuarioIncorreto"
                    >Usuário ou senha incorretos</b-alert
                  >
                  <b-input-group class="mb-3">
                    <b-input-group-prepend>
                      <b-input-group-text>
                        <i class="icon-shield"></i>
                      </b-input-group-text>
                    </b-input-group-prepend>
                    <the-mask
                      id="cnpj"
                      ref="cnpj"
                      :mask="['##.###.###/####-##']"
                      type="text"
                      class="form-control"
                      placeholder="CNPJ"
                      :masked="true"
                      v-model="cnpj"
                      required
                      autofocus
                      @keyup.enter="focus('senha')"
                    />
                    <b-input-group-append ref="cnpjerror" v-if="cnpjError">
                      <b-input-group-text>
                        <i
                          class="fa fa-exclamation-triangle"
                          style="color: red"
                          id="CNPJPopover"
                        ></i>
                      </b-input-group-text>
                      <b-popover
                        :show.sync="cnpjError"
                        placement="right"
                        target="CNPJPopover"
                      >
                        Este campo
                        <strong>não</strong> pode ficar
                        <strong ref="cnpjincompleto" v-if="cnpjIncompleto"
                          >incompleto</strong
                        >
                        <strong v-else>vazio</strong>
                      </b-popover>
                    </b-input-group-append>
                  </b-input-group>
                  <b-input-group class="mb-3">
                    <b-input-group-prepend>
                      <b-input-group-text>
                        <i class="icon-user"></i>
                      </b-input-group-text>
                    </b-input-group-prepend>
                    <b-form-input
                      type="text"
                      class="form-control"
                      placeholder="Usuário"
                      id="usuario"
                      v-model="usuario"
                      required
                      @keyup.enter="focus('senha')"
                      @keyup.esc="focus('cnpj')"
                    />
                    <b-input-group-append
                      ref="usuarioerror"
                      v-if="usuarioError"
                    >
                      <b-input-group-text>
                        <i
                          class="fa fa-exclamation-triangle"
                          style="color: red"
                          id="UsuarioPopover"
                        ></i>
                      </b-input-group-text>
                      <b-popover
                        :show.sync="usuarioError"
                        placement="right"
                        target="UsuarioPopover"
                      >
                        Este campo
                        <strong>não</strong> pode ficar
                        <strong>vazio</strong>
                      </b-popover>
                    </b-input-group-append>
                  </b-input-group>
                  <b-input-group class="mb-4">
                    <b-input-group-prepend>
                      <b-input-group-text>
                        <i class="icon-lock"></i>
                      </b-input-group-text>
                    </b-input-group-prepend>
                    <b-form-input
                      type="password"
                      class="form-control"
                      placeholder="Senha"
                      v-model="senha"
                      required
                      id="senha"
                      @keyup.esc="focus('usuario')"
                    />
                    <b-input-group-append ref="senhaerror" v-if="senhaError">
                      <b-input-group-text>
                        <i
                          class="fa fa-exclamation-triangle"
                          style="color: red"
                          id="SenhaPopover"
                        ></i>
                      </b-input-group-text>
                      <b-popover
                        :show.sync="senhaError"
                        placement="right"
                        target="SenhaPopover"
                      >
                        Este campo
                        <strong>não</strong> pode ficar
                        <strong>vazio</strong>
                      </b-popover>
                    </b-input-group-append>
                  </b-input-group>
                  <b-row>
                    <b-col cols="4">
                      <b-button
                        variant="danger"
                        class="active px-4"
                        type="submit"
                        id="entrar"
                        @click="handleSubmit"
                        >Entrar</b-button
                      >
                    </b-col>
                    <b-col cols="8" class="text-right">
                      <b-button
                        variant="link"
                        class="px-0"
                        v-b-tooltip.hover
                        title="Entre em contato conosco para redefinir sua senha!"
                        style="font-weight: 500; color: #585858"
                        >Esqueceu sua senha?</b-button
                      >
                    </b-col>
                  </b-row>
                </b-form>
              </b-card-body>
            </b-card>
            <b-card
              no-body
              class="text-white bg-danger py-5 d-md-down-none"
              style="width: 44%"
            >
              <b-card-body>
                <div>
                  <h3 class="text-center mb-2">Plataforma de Fidelização</h3>
                  <p class="text-justify">
                    Com nosso programa de fidelização, trace perfis de clientes,
                    adquira total controle sobre suas vendas e direcione cada
                    vez mais seu empreendimento para o sucesso!
                  </p>
                  <p class="text-right">
                    <small>- Feito por Accesys Solutions</small>
                  </p>
                  <p>
                    <a href="http://accesys.com.br/" target="_blank">
                      <b-button variant="danger" class="active m-w"
                        >Entre em contato!</b-button
                      >
                    </a>
                  </p>
                </div>
              </b-card-body>
            </b-card>
          </b-card-group>
        </b-col>
      </b-row>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import { TheMask } from "vue-the-mask";
import Loading from "vue-loading-overlay";
import * as config from "@/config.json";
import SlimDialog from "v-slim-dialog";

export default {
  name: "Login",
  components: { TheMask, Loading, alert, SlimDialog },
  data() {
    return {
      cnpj: "",
      usuario: "",
      senha: "",
      cnpjError: false,
      cnpjIncompleto: false,
      usuarioError: false,
      senhaError: false,
      isLoading: false,
      usuarioIncorreto: false,
      contemErro: false,
      showDismissibleAlert: false,
      erroRenderizado: false,
    };
  },
  methods: {
    focus(id) {
      document.getElementById(id).focus();
    },

    validarCampos() {
      this.cnpjError = false;
      this.cnpjIncompleto = false;
      this.senhaError = false;
      this.usuarioError = false;
      this.contemErro = false;
      if (this.cnpj.length == 0) {
        this.cnpjError = true;
        this.contemErro = true;
      } else if (this.cnpj.length < 14) {
        this.cnpjError = true;
        this.cnpjIncompleto = true;
        this.contemErro = true;
      }
      if (this.usuario.length == 0) {
        this.usuarioError = true;
        this.contemErro = true;
      }
      if (this.senha.length == 0) {
        this.senhaError = true;
        this.contemErro = true;
      }
    },

    async handleSubmit(e) {
      e.preventDefault();
      this.validarCampos();
      if (!this.contemErro) {
        var resposta = await this.handle();
        console.info({ resposta });
      }
    },

    async handle() {
      const data = {
        cnpj: this.cnpj,
        usuario: this.usuario,
        senha: this.senha,
      };

      const url = `${config.default.servidor}/auth/autorizar-gerencial`;

      try {
        const response = await axios({
          url,
          method: "post",
          data,
          headers: { authorization: config.default.authorizationBasic },
        });

        if (response.status == 200) {
          this.usuarioError = false;
          localStorage.setItem("user", this.usuario);
          localStorage.setItem("cnpj", this.cnpj);
          localStorage.setItem("jwt", "1");
          localStorage.setItem("enterprise_id", response.data.enterprise_id);
          localStorage.setItem(
            "enterprise_fantasy",
            response.data.enterprise_fantasy
          );
          localStorage.setItem("app_version", response.data.app_version);
          if (localStorage.getItem("jwt") != null) {
            this.$emit("loggedIn");
            if (this.$route.params.nextUrl != null) {
              this.$router.push(this.$route.params.nextUrl);
            } else {
              this.$router.push("relatorios");
            }
          } else {
            this.mostraErro();
          }
        }
      } catch (error) {
        console.log({ error });
        this.mostraErro();
      }
    },
    async mostraErro() {
      await this.$alert(
        "CNPJ, usuário ou senha não conferem!",
        "Aviso",
        "warning"
      );
      this.$refs.cnpj.$el.focus();
    },
  },
};
</script>
